import React, { useEffect, createElement } from 'react';
import { CheckIcon, ShieldCheckIcon, BookOpenIcon, UtensilsIcon, BrainCircuitIcon, ActivityIcon, LayoutIcon, LockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CTAButton } from './CTAButton';
import { SocialProofPopup } from './SocialProofPopup';
import { TestimonialCard } from './TestimonialCard';
import { FAQAccordion } from './FAQAccordion';
export function SalesPage() {
  // Facebook Pixel Integration
  useEffect(() => {
    // Check if pixel is already initialized to avoid duplicates
    const scriptId = 'facebook-pixel-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '904978025482552');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1" />`;
      document.body.appendChild(noscript);
    }
  }, []);
  const checkoutUrl = 'https://pagos.fegion.online/cart/45638802243723:1';
  return <div className="font-sans text-gray-900 bg-gray-50 min-h-screen pb-20" data-id="element-20">
      <CountdownTimer data-id="element-21" />
      <SocialProofPopup data-id="element-22" />

      {/* HERO SECTION */}
      <section className="bg-white pt-8 pb-12 px-4 md:pt-12 md:pb-16 overflow-hidden" data-id="element-23">
        <div className="max-w-4xl mx-auto text-center" data-id="element-24">
          <p className="text-purple-700 font-bold text-lg md:text-xl mb-4 tracking-wide uppercase" data-id="element-25">
            🟣 Para personas que quieren desinflamarse y recuperar energía
          </p>

          <h1 className="text-5xl md:text-7xl font-extrabold text-gray-900 mb-8 leading-tight tracking-tight" data-id="element-26">
            RESET CORPORAL <span className="text-green-600" data-id="element-27">30D</span>
          </h1>

          <div className="relative mx-auto max-w-2xl mb-8 group cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" data-id="element-28">
            <a href={checkoutUrl} data-id="element-29">
              <div className="absolute -inset-1 bg-gradient-to-r from-green-400 to-blue-500 rounded-2xl blur opacity-30 group-hover:opacity-50 transition duration-200" data-id="element-30"></div>
              <img src="https://cdn.magicpatterns.com/uploads/dMiuYpxDAfdCCEJFVCWzWS/ChatGPT_Image_26_feb_2026,_05_12_13.png" alt="Reset Corporal 30D Producto Principal" className="relative rounded-xl shadow-2xl w-full h-auto border border-gray-100" data-id="element-31" />
            </a>
          </div>

          <p className="text-xl md:text-2xl text-gray-700 font-medium max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-32">
            El sistema estructurado para transformar tu cuerpo en 30 días.{' '}
            <br className="hidden md:block" data-id="element-33" />
            <span className="bg-yellow-100 px-1" data-id="element-34">
              Menos inflamación, más energía y hasta 4–5 kg menos
            </span>{' '}
            sin dietas extremas.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-35">
            <CTAButton className="w-full md:w-auto md:min-w-[400px]" data-id="element-36" />
            <div className="flex items-center gap-2 text-sm font-semibold text-gray-600" data-id="element-37">
              <ShieldCheckIcon className="w-5 h-5 text-green-600" data-id="element-38" />✅ Garantía
              de satisfacción de 7 días
            </div>
          </div>
        </div>
      </section>

      {/* PAIN POINTS SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-39">
        <div className="max-w-3xl mx-auto" data-id="element-40">
          <h2 className="text-3xl font-bold text-center mb-10 text-gray-900" data-id="element-41">
            Déjame hacerte una pregunta honesta…
          </h2>

          <div className="space-y-6 bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-42">
            {['¿Te sientes inflamado/a aunque “no comas tanto”?', '¿Empiezas dietas con motivación… pero a las dos semanas abandonas?', '¿Te gana la ansiedad por la noche?', '¿Sientes que necesitas estructura pero no sabes por dónde empezar?'].map((question, i) => <div key={i} className="flex items-start gap-4" data-id="element-43">
                <div className="bg-red-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-44">
                  <span className="text-red-600 font-bold text-lg" data-id="element-45">?</span>
                </div>
                <p className="text-lg md:text-xl font-medium text-gray-800" data-id="element-46">
                  {question}
                </p>
              </div>)}
          </div>

          <div className="mt-12 text-center space-y-6" data-id="element-47">
            <p className="text-2xl font-bold text-gray-900" data-id="element-48">No estás solo/a.</p>
            <p className="text-lg text-gray-700" data-id="element-49">
              No es falta de fuerza de voluntad. No es que “no sirvas para las
              dietas”.
            </p>
            <p className="text-xl font-semibold text-gray-900 bg-gray-200 inline-block px-4 py-2 rounded-lg" data-id="element-50">
              Es que nadie te dio un sistema claro, estructurado y sostenible.
            </p>
            <p className="text-lg text-gray-700" data-id="element-51">
              Y sin sistema… todo termina igual.
            </p>
          </div>
        </div>
      </section>

      {/* THE PROBLEM SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-52">
        <div className="max-w-3xl mx-auto" data-id="element-53">
          <h2 className="text-3xl font-bold text-center mb-8" data-id="element-54">
            El problema que nadie te explica
          </h2>
          <p className="text-lg text-gray-600 text-center mb-10" data-id="element-55">
            Si has intentado bajar de peso antes, esto te resultará familiar:
          </p>

          <div className="grid gap-4 md:grid-cols-2" data-id="element-56">
            {['Pasas de dieta en dieta', 'Eliminas alimentos y luego los recuperas con culpa', 'Pierdes peso rápido… y lo recuperas más rápido', 'No sabes cómo controlar la ansiedad', 'No tienes una estructura clara', 'Empiezas fuerte… y abandonas a mitad de camino'].map((item, i) => <div key={i} className="flex items-center gap-3 p-4 bg-red-50 rounded-lg border border-red-100" data-id="element-57">
                <div className="w-2 h-2 bg-red-500 rounded-full" data-id="element-58"></div>
                <span className="text-gray-800 font-medium" data-id="element-59">{item}</span>
              </div>)}
          </div>

          <div className="mt-12 text-center bg-gray-900 text-white p-8 rounded-2xl shadow-xl" data-id="element-60">
            <p className="text-xl font-medium mb-2 opacity-90" data-id="element-61">
              Lo peor no es el peso.
            </p>
            <p className="text-2xl md:text-3xl font-bold text-yellow-400" data-id="element-62">
              Es la sensación constante de: “Empiezo el lunes… otra vez.”
            </p>
          </div>
        </div>
      </section>

      {/* THE SOLUTION SECTION */}
      <section className="py-20 px-4 bg-green-50 border-y border-green-100" data-id="element-63">
        <div className="max-w-4xl mx-auto text-center" data-id="element-64">
          <div className="inline-block bg-green-600 text-white px-4 py-1 rounded-full text-sm font-bold tracking-wider mb-6" data-id="element-65">
            ✅ LA SOLUCIÓN
          </div>
          <h2 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-6" data-id="element-66">
            RESET CORPORAL 30D
          </h2>
          <p className="text-xl text-gray-700 mb-12 max-w-2xl mx-auto" data-id="element-67">
            Un sistema completo diseñado para personas ocupadas que quieren
            resultados reales sin extremos.
          </p>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-68">
            {[{
            icon: '📂',
            text: 'Accedes al programa'
          }, {
            icon: '👆',
            text: 'Sigues la estructura diaria'
          }, {
            icon: '🔥',
            text: 'Ejecutas durante 30 días'
          }].map((step, i) => <div key={i} className="bg-white p-8 rounded-xl shadow-md border border-green-100 flex flex-col items-center" data-id="element-69">
                <span className="text-5xl mb-4" data-id="element-70">{step.icon}</span>
                <span className="font-bold text-lg text-gray-900" data-id="element-71">
                  {step.text}
                </span>
              </div>)}
          </div>

          <p className="text-lg font-medium text-gray-800 mb-8" data-id="element-72">
            Sin improvisar. Sin pasar hambre extrema. Sin entrenamientos
            imposibles.
            <br data-id="element-73" />
            <span className="text-2xl font-bold text-green-700 block mt-2" data-id="element-74">
              Solo estructura clara.
            </span>
          </p>
        </div>
      </section>

      {/* WHAT'S INCLUDED SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-75">
        <div className="max-w-4xl mx-auto" data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-77">
            📘 ¿Qué incluye exactamente RESET CORPORAL 30D?
          </h2>
          <p className="text-center text-gray-600 mb-12 text-lg" data-id="element-78">
            Un sistema dividido en 5 módulos estratégicos:
          </p>

          <div className="space-y-6" data-id="element-79">
            {[{
            icon: <BookOpenIcon className="w-8 h-8 text-blue-500" data-id="element-80" />,
            title: 'TOMO 1 – Fundamentos del Cambio',
            desc: 'Entiende cómo funciona realmente la pérdida de grasa y prepara tu mente para 30 días de estructura real.',
            color: 'bg-blue-50 border-blue-100'
          }, {
            icon: <UtensilsIcon className="w-8 h-8 text-green-500" data-id="element-81" />,
            title: 'TOMO 2 – Nutrición Inteligente',
            desc: 'Método del plato, organización en 60 minutos y menú base simple para crear déficit sin hambre extrema.',
            color: 'bg-green-50 border-green-100'
          }, {
            icon: <BrainCircuitIcon className="w-8 h-8 text-orange-500" data-id="element-82" />,
            title: 'TOMO 3 – Control de Ansiedad',
            desc: 'Técnicas prácticas para frenar impulsos, romper el ciclo culpa–exceso y recuperar el control.',
            color: 'bg-orange-50 border-orange-100'
          }, {
            icon: <ActivityIcon className="w-8 h-8 text-red-500" data-id="element-83" />,
            title: 'TOMO 4 – Movimiento Estratégico',
            desc: 'Rutinas de 20 minutos en casa + activación metabólica sin necesidad de gimnasio.',
            color: 'bg-red-50 border-red-100'
          }, {
            icon: <LayoutIcon className="w-8 h-8 text-purple-500" data-id="element-84" />,
            title: 'TOMO 5 – Abdomen Plano y Mantenimiento',
            desc: 'Protocolo antiinflamación + estrategia clara para evitar el efecto rebote.',
            color: 'bg-purple-50 border-purple-100'
          }].map((module, i) => <div key={i} className={`flex flex-col md:flex-row gap-6 p-6 rounded-xl border ${module.color} transition-all hover:shadow-md`} data-id="element-85">
                <div className="bg-white p-4 rounded-full shadow-sm w-fit h-fit self-start md:self-center" data-id="element-86">
                  {module.icon}
                </div>
                <div data-id="element-87">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-88">
                    {module.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-89">{module.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-90">
            <p className="text-xl font-medium text-gray-800 mb-8" data-id="element-91">
              Todo organizado paso a paso para que no tengas que pensar qué
              hacer cada día.
            </p>
            <CTAButton text="👉 ACCEDER AHORA CON DESCUENTO" data-id="element-92" />
          </div>
        </div>
      </section>

      {/* BEFORE VS AFTER SECTION */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-93">
        <div className="max-w-5xl mx-auto" data-id="element-94">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-95">
            Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-8 md:gap-16" data-id="element-96">
            <div className="bg-gray-800 p-8 rounded-2xl border border-gray-700" data-id="element-97">
              <h3 className="text-2xl font-bold text-red-400 mb-6 border-b border-gray-700 pb-4" data-id="element-98">
                Antes del Reset
              </h3>
              <ul className="space-y-4" data-id="element-99">
                {['Inflamación constante', 'Cansancio diario', 'Ansiedad nocturna', 'Ropa ajustada', 'Empezar dietas cada lunes', 'Culpa después de comer'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-300" data-id="element-100">
                    <span className="text-red-500 text-xl" data-id="element-101">✖</span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-gray-800 p-8 rounded-2xl border-2 border-green-500 shadow-[0_0_30px_rgba(34,197,94,0.2)] relative overflow-hidden" data-id="element-102">
              <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-103">
                OBJETIVO
              </div>
              <h3 className="text-2xl font-bold text-green-400 mb-6 border-b border-gray-700 pb-4" data-id="element-104">
                Después de 30 días
              </h3>
              <ul className="space-y-4" data-id="element-105">
                {['Menos inflamación abdominal', 'Más energía estable', 'Mayor control emocional', 'Ropa más suelta', 'Estructura clara', 'Resultados sostenibles'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white font-medium" data-id="element-106">
                    <CheckIcon className="w-5 h-5 text-green-500" data-id="element-107" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center mt-12" data-id="element-108">
            <p className="text-2xl font-bold text-white" data-id="element-109">
              No es solo bajar peso.{' '}
              <span className="text-yellow-400" data-id="element-110">Es recuperar control.</span>
            </p>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-20 px-4 bg-gradient-to-b from-white to-gray-50" data-id="element-111">
        <div className="max-w-4xl mx-auto" data-id="element-112">
          <div className="text-center mb-16" data-id="element-113">
            <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-4" data-id="element-114">
              🎁 Bonos especiales incluidos hoy
            </h2>
            <p className="text-xl text-gray-600 font-medium" data-id="element-115">
              (Sin costo adicional)
            </p>
          </div>

          <div className="space-y-16" data-id="element-116">
            {/* Bonus 1 */}
            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-117">
              <div className="w-full md:w-1/2 flex justify-center" data-id="element-118">
                <img src="https://cdn.magicpatterns.com/uploads/wZLSAtXtfUbLQFxspPb7Zq/bono_1.png" alt="Bono 1 Planificador" className="w-full max-w-[400px] h-auto rounded-lg shadow-xl hover:scale-105 transition-transform duration-300" data-id="element-119" />
              </div>
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-120">
                <div className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-bold mb-4" data-id="element-121">
                  🎁 Bono #1
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-122">
                  Planificador Reset 30D
                </h3>
                <p className="text-gray-600 text-lg mb-4" data-id="element-123">
                  Sistema de seguimiento diario + tracker de hábitos.
                </p>
                <p className="text-xl font-bold text-green-600" data-id="element-124">HOY: GRATIS</p>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12" data-id="element-125">
              <div className="w-full md:w-1/2 flex justify-center" data-id="element-126">
                <img src="https://cdn.magicpatterns.com/uploads/5ctXKaGVxHz9K8AuWVkhXK/bono_2.png" alt="Bono 2 Recetario" className="w-full max-w-[400px] h-auto rounded-lg shadow-xl hover:scale-105 transition-transform duration-300" data-id="element-127" />
              </div>
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-128">
                <div className="inline-block bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm font-bold mb-4" data-id="element-129">
                  🎁 Bono #2
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-130">
                  Recetario Express RESET 30D
                </h3>
                <p className="text-gray-600 text-lg mb-4" data-id="element-131">
                  Recetas listas en 20 minutos o menos para mantener tu déficit
                  sin complicaciones.
                </p>
                <p className="text-xl font-bold text-green-600" data-id="element-132">HOY: GRATIS</p>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-133">
              <div className="w-full md:w-1/2 flex justify-center" data-id="element-134">
                <img src="https://cdn.magicpatterns.com/uploads/rrey8BvZ3nZLY1HVRLARgm/bono_3.png" alt="Bono 3 Guía Comer Fuera" className="w-full max-w-[400px] h-auto rounded-lg shadow-xl hover:scale-105 transition-transform duration-300" data-id="element-135" />
              </div>
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-136">
                <div className="inline-block bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm font-bold mb-4" data-id="element-137">
                  🎁 Bono #3
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-138">
                  Guía Inteligente para Comer Fuera
                </h3>
                <p className="text-gray-600 text-lg mb-4" data-id="element-139">
                  Estrategias claras para restaurantes y eventos sociales sin
                  sabotear resultados.
                </p>
                <p className="text-xl font-bold text-green-600" data-id="element-140">HOY: GRATIS</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OFFER / PRICING SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-141">
        <div className="max-w-3xl mx-auto" data-id="element-142">
          <div className="bg-white border-2 border-dashed border-gray-300 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-143">
            <div className="absolute top-0 right-0 bg-red-600 text-white px-8 py-2 font-bold transform rotate-45 translate-x-8 translate-y-4 shadow-md" data-id="element-144">
              OFERTA
            </div>

            <div className="text-center mb-10" data-id="element-145">
              <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-146">
                ⏰ Oferta por tiempo limitado
              </h2>
              <p className="text-gray-600" data-id="element-147">Accede hoy a:</p>
            </div>

            <div className="space-y-3 mb-10 max-w-md mx-auto" data-id="element-148">
              {['Sistema completo RESET CORPORAL 30D', '5 Tomos estructurados', '3 Bonos exclusivos', 'Acceso inmediato', 'Descarga digital', 'Un solo pago'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-149">
                  <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-150" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-151">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="text-center border-t border-gray-100 pt-8" data-id="element-152">
              <p className="text-gray-500 line-through text-xl mb-2" data-id="element-153">
                Precio regular: $49.990
              </p>
              <p className="text-5xl md:text-6xl font-extrabold text-green-600 mb-4" data-id="element-154">
                HOY SOLO: $19.990
              </p>
              <p className="text-sm text-gray-500 mb-8" data-id="element-155">
                Pagas en tu moneda local
              </p>

              <CTAButton text="👉 COMENZAR MI RESET AHORA" fullWidth className="max-w-md mx-auto" data-id="element-156" />
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-157">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8 bg-white p-8 rounded-2xl shadow-sm border border-gray-200" data-id="element-158">
          <div className="flex-shrink-0" data-id="element-159">
            <div className="w-32 h-32 bg-yellow-100 rounded-full flex items-center justify-center border-4 border-yellow-300" data-id="element-160">
              <ShieldCheckIcon className="w-16 h-16 text-yellow-600" data-id="element-161" />
            </div>
          </div>
          <div className="text-center md:text-left" data-id="element-162">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-163">
              🛡 Garantía sin riesgo
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-164">
              Prueba <span className="font-bold" data-id="element-165">RESET CORPORAL 30D</span>{' '}
              durante 7 días.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-166">
              Si sientes que no es para ti, puedes solicitar el 100% de tu
              dinero.
            </p>
            <p className="font-bold text-gray-900" data-id="element-167">
              Sin preguntas. Sin riesgo.
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-white" data-id="element-168">
        <div className="max-w-6xl mx-auto" data-id="element-169">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-170">
            Lo que dicen quienes ya hicieron su Reset
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-171">
            <TestimonialCard quote="En 3 semanas la inflamación bajó muchísimo. Mi ropa volvió a quedarme cómoda." data-id="element-172" />
            <TestimonialCard quote="Por primera vez no sentí ansiedad constante. Tener estructura lo cambió todo." data-id="element-173" />
            <TestimonialCard quote="No es otra dieta. Es un sistema que realmente puedo repetir." data-id="element-174" />
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-175">
        <div className="max-w-3xl mx-auto" data-id="element-176">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-177">
            Preguntas frecuentes
          </h2>
          <FAQAccordion data-id="element-178" />
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 px-4 bg-gray-900 text-white text-center" data-id="element-179">
        <div className="max-w-3xl mx-auto" data-id="element-180">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-181">
            Tu cuerpo puede cambiar en 30 días
          </h2>
          <p className="text-xl text-gray-300 mb-4" data-id="element-182">No necesitas otra dieta.</p>
          <p className="text-2xl font-bold text-white mb-8" data-id="element-183">
            Necesitas estructura.
          </p>

          <p className="text-lg text-gray-400 mb-10 leading-relaxed" data-id="element-184">
            RESET CORPORAL 30D es un sistema que puedes repetir cada vez que lo
            necesites.
            <br data-id="element-185" />
            Menos inflamación. Más energía. Más control.
          </p>

          <CTAButton text="👉 Empieza hoy tu RESET CORPORAL 30D" data-id="element-186" />

          <div className="mt-12 flex items-center justify-center gap-4 opacity-50 grayscale" data-id="element-187">
            <LockIcon className="w-5 h-5" data-id="element-188" />
            <span className="text-sm" data-id="element-189">Pago 100% Seguro y Encriptado</span>
          </div>
        </div>
      </section>

      <footer className="bg-black text-gray-600 py-8 text-center text-sm" data-id="element-190">
        <div className="container mx-auto px-4" data-id="element-191">
          <p data-id="element-192">
            &copy; {new Date().getFullYear()} Reset Corporal 30D. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-193">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}